import React, { Component } from 'react'
import { MuiTypography, MuiGrid, MuiAddCircle } from '../../../ui/MaterialUIComponents'
import theme from '../../../../assests'
import { CreateCalendarComponent } from '.'
import { TeacherCardComponent } from '../teacher/TeacherCardComponent';
import WeeklyCalendarCard from './WeeklyCalendarCard'


class AddNewCalendar extends Component {
	constructor(props) {
		super(props)
	}
	showContextualHelp = (props, event) => {
		let content = props.contextualHelp["bellTimes"];
		if (content !== undefined) {
			props.toggleDrawer("right", true, content)(event)
		}
	}
	render() {
		const i18n = this.props.i18n
		return (
			<MuiGrid container spacing={1} >
				{/* {this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].weeklyCalendar.length > 0
					&& this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].weeklyCalendar.map((cal, index) =>
						<MuiGrid item xs={6} id="grid">
							{this.props.showCard && cal ?
								<WeeklyCalendarCard
									{...this.props}
									cal={cal}
									calIndex={index}
								/> : null}
						</MuiGrid>
					)}
					
				<MuiGrid item xs={12} >
					{this.props.showAddNewCalendar ?
						<CreateCalendarComponent
							{...this.props}
							{...this.state} 
							showContextualHelp={this.showContextualHelp}/>
						:
						this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].weeklyCalendar.length === 0 &&
						<MuiGrid container xs={5} spacing={1} justify="center" alignItems="center" style={{ padding: 15, border: "2px solid " + theme.palette.grey.dark, cursor: "pointer" }} onClick={this.props.addNewCalendar}>
							<MuiGrid item >

								<MuiAddCircle style={{ color: theme.palette.orange }} fontSize='large' />

							</MuiGrid>
							<MuiGrid item >
								<MuiTypography style={theme.addMoreStyle}>
									{i18n.calendar.addBellTime}
                            </MuiTypography>
							</MuiGrid>
						</MuiGrid>}
				</MuiGrid> */}
				<CreateCalendarComponent
					{...this.props}
					{...this.state}
					showContextualHelp={this.showContextualHelp} />
			</MuiGrid>
		)
	}
}
export default AddNewCalendar